"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _http_request = _interopRequireDefault(require("../request/http_request"));
var _utils = require("../utils");
var _Reader = require("../constants/Reader");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var TrackingService = auth => {
  var applicationToken = auth.applicationToken;
  var sessionToken = auth.sessionToken;
  var userId = auth.userId;
  var uuid = auth.uuid;
  var bookTitle = auth.bookTitle;
  var {
    buildHeader,
    post
  } = (0, _http_request.default)(applicationToken, sessionToken);
  var sendTrack = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (data) {
      var headers = {};
      var path = 'tracker/api/v1/event';
      headers = buildHeader(headers);
      var newData = _objectSpread(_objectSpread({}, data), {}, {
        screen_width: window.screen.width,
        browser_language: navigator.language,
        path: window.location.pathname,
        referrer: document.referrer,
        url: window.location.href,
        user_agent: navigator.userAgent,
        device_type: (0, _utils.getDeviceType)(),
        integration_type: (0, _utils.getIntegrationType)(),
        user_id: userId,
        session_token: sessionToken,
        resource_name: bookTitle,
        resource_uuid: uuid,
        sended_at: new Date().toISOString()
      });
      var response = yield post(path, newData, headers);
      return response;
    });
    return function sendTrack(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var trackPageView = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'pageview',
          current_page: payload.currentPage
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackPageView(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var trackAccessIndex = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* () {
      try {
        var response = yield sendTrack({
          event: 'opened_index'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackAccessIndex() {
      return _ref3.apply(this, arguments);
    };
  }();
  var trackChapterSelected = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'navigated_index'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackChapterSelected(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var trackReferenceCopy = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'copied_bibliographic_reference'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackReferenceCopy(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  var trackBookmark = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'bookmarked_page'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackBookmark(_x5) {
      return _ref6.apply(this, arguments);
    };
  }();
  var trackAccessBookmark = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(function* (book) {
      try {
        var response = yield sendTrack({
          event: 'opened_bookmarks'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackAccessBookmark(_x6) {
      return _ref7.apply(this, arguments);
    };
  }();
  var trackAddBooknote = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'added_note'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackAddBooknote(_x7) {
      return _ref8.apply(this, arguments);
    };
  }();
  var trackColorHighlight = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'added_text_highlight'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackColorHighlight(_x8) {
      return _ref9.apply(this, arguments);
    };
  }();
  var trackColorHighlightEdit = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'edited_text_highlight'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackColorHighlightEdit(_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
  var trackChangeFontSize = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'changed_text_style'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackChangeFontSize(_x10) {
      return _ref11.apply(this, arguments);
    };
  }();
  var trackChangeBackgroundColor = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'changed_background_style'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackChangeBackgroundColor(_x11) {
      return _ref12.apply(this, arguments);
    };
  }();
  var trackAccessHighlight = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(function* (book) {
      try {
        var response = yield sendTrack({
          event: 'opened_highlights'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackAccessHighlight(_x12) {
      return _ref13.apply(this, arguments);
    };
  }();
  var trackEditHighlight = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'edited_note'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackEditHighlight(_x13) {
      return _ref14.apply(this, arguments);
    };
  }();
  var trackCopyText = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'copied_book_excerpt'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackCopyText(_x14) {
      return _ref15.apply(this, arguments);
    };
  }();
  var trackDeleteHighlight = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(function* (payload) {
      try {
        var response = yield sendTrack({
          event: 'deleted_highlight'
        });
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
      } catch (error) {
        // TODO: SEND TO BUGSNAG
        console.error(error);
      }
    });
    return function trackDeleteHighlight(_x15) {
      return _ref16.apply(this, arguments);
    };
  }();
  return {
    sendTrack,
    trackPageView,
    trackAccessIndex,
    trackChapterSelected,
    trackReferenceCopy,
    trackAccessBookmark,
    trackBookmark,
    trackAddBooknote,
    trackColorHighlight,
    trackColorHighlightEdit,
    trackChangeFontSize,
    trackChangeBackgroundColor,
    trackAccessHighlight,
    trackEditHighlight,
    trackCopyText,
    trackDeleteHighlight
  };
};
var _default = exports.default = TrackingService;